import React, { useState } from "react";
import { ProfileCard, LocationDrawer } from "@viewComponents/profile_utils";

interface Location {
  id: number;
  name: string;
  surface?: number;
  price?: string;
  chalandise?: number | null;
  walls_for_sale?: boolean;
  business_for_sale?: boolean;
  lease_for_sale?: boolean;
  popup_available?: boolean;
  address?: {
    postal_code: string;
    locality: string;
    formatted_address: string;
    latitude: number;
    longitude: number;
    administrative_area_level_1?: string | null;
    country: string;
  } | null;
}

interface SearchLocationsProps {
  count: number;
  locations?: Location[];
  message?: string;
}

export const SearchLocationsResult: React.FC<SearchLocationsProps> = ({
  count,
  locations = [],
  message,
}) => {
  const [selectedLocation, setSelectedLocation] = useState<Location | null>(
    null,
  );

  if (count === 0 || message) {
    return (
      <div className="rounded-lg border border-gray-200 bg-gray-50 p-4 text-sm text-gray-600">
        {message || "Aucun emplacement trouvé"}
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <div className="text-sm font-medium text-gray-700">
        {count} emplacement{count > 1 ? "s" : ""} trouvé{count > 1 ? "s" : ""}
      </div>
      <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
        {locations.map((location) => {
          // Map to ProfileCard expected format
          const mappedLocation = {
            id: location.id,
            name: location.name,
            logo_url: undefined,
            surface: location.surface,
            price: location.price,
            address: location.address?.formatted_address,
          };

          return (
            <ProfileCard
              key={location.id}
              entity={mappedLocation}
              entityType="locations"
              onClick={() => setSelectedLocation(location)}
              onDetailClick={() => setSelectedLocation(location)}
            />
          );
        })}
      </div>

      {selectedLocation && (
        <LocationDrawer
          location={selectedLocation}
          onClose={() => setSelectedLocation(null)}
        />
      )}
    </div>
  );
};
